
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/last-name/[lastname_slug]",
      function () {
        return require("private-next-pages/last-name/[lastname_slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/last-name/[lastname_slug]"])
      });
    }
  